<template>
  <validation-observer
    ref="historyFormRef"
  >
    <b-modal
      id="historyModal"
      size="xl"
      centered
      :hide-footer="true"
      :no-close-on-backdrop="true"
      @show="onShow"
      @hide="onHide"
    >
      <template #modal-header="{ close }">
        <div class="history-header">
          <div class="header-content">
            <h4 class="history-title">
              Diễn biến thu học phí
            </h4>
            <div class="student-info">
              <span class="student-name">Sinh viên: {{ currentHSReceipt.full_name || '---' }}</span>
              <span class="student-code">MSSV: {{ currentHSReceipt.student_code || '---' }}</span>
            </div>
          </div>
          <b-button
            variant="link"
            class="close-btn"
            @click="close"
          >
            <feather-icon
              icon="XIcon"
              size="20"
            />
          </b-button>
        </div>
      </template>

      <b-overlay
        :show="isLoading"
        rounded="sm"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
      >
        <div class="history-content">
          <b-table
            :items="allHistoryItems"
            :fields="historyFields"
            class="history-table"
            hover
            responsive
          >
            <template #cell(category)="data">
              <span
                class="category-badge"
                :class="getCategoryClass(data.item.category_type)"
              >
                {{ data.item.category }}
              </span>
            </template>
            <template #cell(detail_content)="data">
              <div>
                <div class="detail-text">
                  {{ data.item.detail_content }}
                </div>
                <div
                  v-if="data.item.receipt_code"
                  class="receipt-code"
                >
                  Mã: {{ data.item.receipt_code }}
                </div>
              </div>
            </template>
            <template #cell(payment_date)="data">
              {{ data.item.payment_date || '-' }}
            </template>
            <template #cell(amount)="data">
              <span
                class="amount-text"
                :class="getAmountClass(data.item)"
              >
                {{ formatAmount(data.item) }}
              </span>
            </template>
            <template #cell(status)="data">
              <div class="status-cell">
                <span
                  class="status-dot"
                  :class="getStatusClass(data.item.status_type)"
                />
                <span class="status-text">{{ data.item.status }}</span>
              </div>
            </template>
          </b-table>

          <div class="history-summary">
            <div class="summary-left">
              <div class="summary-item">
                <div class="summary-label">
                  HỌC PHÍ ĐÃ NỘP
                </div>
                <div class="summary-value tuition-paid">
                  {{ formatNumber(totalTuitionPaid) }}
                </div>
              </div>
              <div class="summary-item">
                <div class="summary-label">
                  MIỄN GIẢM
                </div>
                <div class="summary-value exemption">
                  {{ formatNumber(totalExemption) }}
                </div>
              </div>
              <div class="summary-item">
                <div class="summary-label">
                  KHOẢN THU KHÁC
                </div>
                <div class="summary-value other-fee">
                  {{ formatNumber(totalOtherFee) }}
                </div>
              </div>
            </div>
            <div class="summary-right">
              <b-button
                variant="outline-primary"
                class="export-btn"
                @click="onExport"
              >
                <feather-icon
                  icon="PrinterIcon"
                  size="18"
                  class="mr-1"
                />
                XUẤT BIÊN LAI
              </b-button>
              <b-button
                variant="primary"
                class="close-btn-action"
                @click="$bvModal.hide('historyModal')"
              >
                ĐÓNG
              </b-button>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BModal,
  BOverlay,
  BTable,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import receiptApi from '@/views/finance/receipt/api'

export default {
  name: 'HistoryReceipt',
  components: {
    BTable,
    BModal,
    BOverlay,
    BButton,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    studentClassesId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      currentHSReceipt: {
        student_classes_id: null,
        student_code: null,
        student_id: null,
        last_name: null,
        first_name: null,
        class_name: null,
        major_name: null,
        full_name: null,
      },
      historyFields: [
        { key: 'semester_name', label: 'KỲ HỌC' },
        { key: 'category', label: 'PHÂN LOẠI' },
        { key: 'detail_content', label: 'NỘI DUNG CHI TIẾT' },
        { key: 'payment_date', label: 'NGÀY NỘP' },
        { key: 'amount', label: 'SỐ TIỀN' },
        { key: 'status', label: 'TRẠNG THÁI' },
      ],
      revenue_dn_items: [],
      revenue_cn_items: [],
      exemption_items: [],
      revenue_ktk_dn_items: [],
      revenue_ktk_cn_items: [],
      // API Response data
      listHistoryStudentInfo: [],
      listHistoryRevenuesCN: [],
      listHistoryRevenuesDN: [],
      listHistoryExemptions: [],
      listHistoryRevenuesKTKCN: [],
      listHistoryRevenuesKTKDN: [],
    }
  },
  computed: {
    allHistoryItems() {
      const items = []
      // Thêm các khoản chưa nộp (HỌC PHÍ)
      this.revenue_cn_items.forEach(item => {
        items.push({
          semester_name: item.semester_name,
          category: 'HỌC PHÍ',
          category_type: 'tuition',
          detail_content: item.receipt_name || 'Nộp học phí',
          payment_date: null,
          amount: item.amount || 0,
          status: 'Chưa nộp',
          status_type: 'unpaid',
        })
      })
      // Thêm các khoản đã nộp (HỌC PHÍ)
      this.revenue_dn_items.forEach(item => {
        items.push({
          semester_name: item.semester_name,
          category: 'HỌC PHÍ',
          category_type: 'tuition',
          detail_content: item.receipt_name || 'Nộp học phí',
          receipt_code: item.receipt_code,
          payment_date: this.formatDate(item.receipt_date),
          amount: item.amount || 0,
          status: 'Đã nộp',
          status_type: 'paid',
        })
      })
      // Thêm các khoản miễn giảm
      this.exemption_items.forEach(item => {
        items.push({
          semester_name: item.semester_name,
          category: 'MIỄN GIẢM',
          category_type: 'exemption',
          detail_content: item.exemption_name || item.revenue_name || 'Miễn giảm',
          receipt_code: item.exemption_code,
          payment_date: this.formatDate(item.exemption_date),
          amount: item.amount || 0,
          status: 'Đã giảm',
          status_type: 'discounted',
        })
      })
      // Thêm các khoản thu khác chưa nộp
      this.revenue_ktk_cn_items.forEach(item => {
        items.push({
          semester_name: item.semester_name,
          category: 'KHOẢN THU KHÁC',
          category_type: 'other',
          detail_content: item.revenue_name || 'Khoản thu khác',
          payment_date: null,
          amount: item.amount || 0,
          status: 'Chưa nộp',
          status_type: 'unpaid',
        })
      })
      // Thêm các khoản thu khác đã nộp
      this.revenue_ktk_dn_items.forEach(item => {
        items.push({
          semester_name: item.semester_name,
          category: 'KHOẢN THU KHÁC',
          category_type: 'other',
          detail_content: item.revenue_name || 'Khoản thu khác',
          receipt_code: item.receipt_code,
          payment_date: this.formatDate(item.receipt_date),
          amount: item.amount || 0,
          status: 'Đã nộp',
          status_type: 'paid',
        })
      })
      return items
    },
    totalTuitionPaid() {
      return this.revenue_dn_items
        .filter(item => item.receipt_name === 'Học phí')
        .reduce((sum, item) => sum + (item.amount || 0), 0)
    },
    totalExemption() {
      return this.exemption_items.reduce((sum, item) => sum + (item.amount || 0), 0)
    },
    totalOtherFee() {
      const tuitionOtherFee = this.revenue_dn_items
        .filter(item => item.receipt_name !== 'Học phí')
        .reduce((sum, item) => sum + (item.amount || 0), 0)
      const ktkFee = this.revenue_ktk_dn_items.reduce((sum, item) => sum + (item.amount || 0), 0)
      return tuitionOtherFee + ktkFee
    },
  },
  methods: {
    async getHistoryReceipt(params) {
      const [
        studentInfo,
        revenuesCN,
        revenuesDN,
        exemptions,
        revenuesKTKCN,
        revenuesKTKDN,
      ] = await Promise.all([
        receiptApi.getHistoryStudentInfo(params),
        receiptApi.getHistoryRevenuesCN(params),
        receiptApi.getHistoryRevenuesDN(params),
        receiptApi.getHistoryExemptions(params),
        receiptApi.getHistoryRevenuesKTKCN(params),
        receiptApi.getHistoryRevenuesKTKDN(params),
      ])

      this.listHistoryStudentInfo = studentInfo
      this.listHistoryRevenuesCN = revenuesCN
      this.listHistoryRevenuesDN = revenuesDN
      this.listHistoryExemptions = exemptions
      this.listHistoryRevenuesKTKCN = revenuesKTKCN
      this.listHistoryRevenuesKTKDN = revenuesKTKDN
    },
    async onShow() {
      this.isLoading = true
      try {
        if (this.studentClassesId) {
          await this.getHistoryReceipt({ student_class_id: this.studentClassesId })
          this.currentHSReceipt = {
            ...this.currentHSReceipt,
            ...this.listHistoryStudentInfo[0],
          }
          this.revenue_dn_items = this.listHistoryRevenuesDN || []
          this.revenue_cn_items = this.listHistoryRevenuesCN || []
          this.exemption_items = this.listHistoryExemptions || []
          this.revenue_ktk_dn_items = this.listHistoryRevenuesKTKDN || []
          this.revenue_ktk_cn_items = this.listHistoryRevenuesKTKCN || []

          // Wait for DOM to render completely before hiding loading
          await this.$nextTick()
          // Additional wait for table to fully render
          await new Promise(resolve => {
            requestAnimationFrame(() => {
              requestAnimationFrame(resolve)
            })
          })
        }
      } finally {
        this.isLoading = false
      }
    },
    onHide() {
      // Reset data when modal closes
      this.revenue_dn_items = []
      this.revenue_cn_items = []
      this.exemption_items = []
      this.revenue_ktk_dn_items = []
      this.revenue_ktk_cn_items = []
    },
    formatDate(value) {
      if (!value) return null
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      const day = `0${date.getDate()}`.slice(-2)
      const month = `0${date.getMonth() + 1}`.slice(-2)
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    formatNumber(value) {
      if (value == null) return '0'
      return new Intl.NumberFormat('vi-VN').format(value)
    },
    formatAmount(item) {
      const amount = item.amount || 0
      const formatted = this.formatNumber(Math.abs(amount))
      return item.category_type === 'exemption' ? `- ${formatted} ₫` : `${formatted} ₫`
    },
    getCategoryClass(categoryType) {
      const classes = {
        tuition: 'category-tuition',
        exemption: 'category-exemption',
        other: 'category-other',
      }
      return classes[categoryType] || ''
    },
    getStatusClass(statusType) {
      const classes = {
        unpaid: 'status-unpaid',
        paid: 'status-paid',
        discounted: 'status-discounted',
      }
      return classes[statusType] || ''
    },
    getAmountClass(item) {
      if (item.status_type === 'unpaid') return 'amount-unpaid'
      if (item.category_type === 'exemption') return 'amount-exemption'
      return 'amount-paid'
    },
    onExport() {
      // TODO: Implement export receipt functionality
    },
  },
}
</script>

<style lang="scss" scoped>
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0.5rem 0;

  .header-content {
    flex: 1;

    .history-title {
      font-weight: 700;
      font-size: 20px;
      color: #1a1a1a;
      margin-bottom: 0.75rem;
    }

    .student-info {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      .student-name,
      .student-code {
        font-size: 14px;
        color: #667085;
      }
    }
  }

  .close-btn {
    padding: 0;
    border: none;
    background: none;
    color: #667085;
    cursor: pointer;

    &:hover {
      color: #1a1a1a;
    }
  }
}

.history-content {
  padding: 1rem 0;
}

.history-table {
  margin-bottom: 2rem;

  ::v-deep thead th {
    background-color: #f9fafb;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    color: #1a1a1a;
    border-bottom: 2px solid #e4e7ec;
    padding: 0.75rem;
  }

  ::v-deep tbody td {
    padding: 1rem 0.75rem;
    vertical-align: middle;
  }
}

.category-badge {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  &.category-tuition {
    background-color: #e0f2fe;
    color: #0369a1;
  }

  &.category-exemption {
    background-color: #fef3c7;
    color: #d97706;
  }

  &.category-other {
    background-color: #f3f4f6;
    color: #6b7280;
  }
}

.detail-text {
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 0.25rem;
}

.receipt-code {
  font-size: 12px;
  color: #667085;
}

.amount-text {
  font-weight: 600;

  &.amount-unpaid {
    color: #dc2626;
  }

  &.amount-exemption {
    color: #d97706;
  }

  &.amount-paid {
    color: #1a1a1a;
  }
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &.status-unpaid {
    background-color: #dc2626;
  }

  &.status-paid {
    background-color: #10b981;
  }

  &.status-discounted {
    background-color: #f59e0b;
  }
}

.status-text {
  font-size: 14px;
  color: #1a1a1a;
}

.history-summary {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 1.5rem;
  border-top: 2px solid #e4e7ec;
  margin-top: 1.5rem;
}

.summary-left {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: flex-end;
}

.summary-item {
  .summary-label {
    font-size: 12px;
    color: #667085;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
  }

  .summary-value {
    font-weight: 700;
    font-size: 24px;

    &.tuition-paid {
      color: #2563eb;
    }

    &.exemption {
      color: #f59e0b;
    }

    &.other-fee {
      color: #6b7280;
    }
  }
}

.summary-right {
  display: flex;
  gap: 0.75rem;
  align-items: center;

  .export-btn {
    border: 1px solid #e4e7ec;
    background-color: #ffffff;
    color: #1a1a1a;
    font-weight: 500;

    &:hover {
      background-color: #f9fafb;
      border-color: #5a60f8;
      color: #5a60f8;
    }
  }

  .close-btn-action {
    background-color: #1e40af;
    border-color: #1e40af;
    font-weight: 600;
    min-width: 100px;

    &:hover {
      background-color: #1e3a8a;
      border-color: #1e3a8a;
    }
  }
}

// Ensure overlay works properly inside modal
::v-deep .b-overlay {
  position: relative;

  .b-overlay-wrap {
    position: relative;
  }
}
</style>
